import {Grid} from '@material-ui/core';
import {PhoneFormatCustom, TextBox} from '../../../Core/UI';
import React, {useCallback} from 'react';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../CategoryCard';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {emailValidator, phoneValidator} from '../../../Core/helpers/validators';
import {STATE_OPTIONS} from '../../constants';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';

type EmergencyContactProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    parameters: Approval;
    setCategory: (entry: string) => void;
    index: number;
};

const EmergencyContact = observer(({valueChanged, parameters, setCategory, index}: EmergencyContactProps) => {
    const phoneValue = useCallback(() => {
        const rawValue = parameters.emergencyEmail.value;
        if (!rawValue) return rawValue;

        const numericValue = rawValue.replace(/[^0-9]/g, '');
        return numericValue.slice(-10);
    }, [parameters.emergencyEmail.value]);

    return (
        <CategoryCard title={'Emergency Contact (VUL Only)'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <TextBox
                    id="emergencyFirstName"
                    label="First Name"
                    value={parameters.emergencyFirstName?.value}
                    onChange={(value) => valueChanged(parameters.emergencyFirstName, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="emergencyLastName"
                    label="Last Name"
                    value={parameters.emergencyLastName?.value}
                    onChange={(value) => valueChanged(parameters.emergencyLastName, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    error={!!parameters.emergencyEmail.value && !emailValidator(parameters.emergencyEmail.value)}
                    id={'emergencyEmail'}
                    label={'Email'}
                    value={parameters.emergencyEmail?.value}
                    onChange={(value) => valueChanged(parameters.emergencyEmail, value)}
                    placeholder="example@gmail.com"
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    error={!!parameters.emergencyPhone.value && !phoneValidator(phoneValue())}
                    id={'emergencyPhone'}
                    label={'Phone Number'}
                    value={phoneValue()}
                    onChange={(value) => valueChanged(parameters.emergencyPhone, value)}
                    placeholder="(323) 232-3123"
                    InputProps={{
                        inputComponent: PhoneFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="emergencyStreetAddr"
                    label="Street Address"
                    value={parameters.emergencyStreetAddr?.value}
                    onChange={(value) => valueChanged(parameters.emergencyStreetAddr, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="emergencyCity"
                    label="City"
                    value={parameters.emergencyCity?.value}
                    onChange={(value) => valueChanged(parameters.emergencyCity, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'State',
                        name: 'emergencyState',
                        options: fieldOptions.emergencyState.options,
                        ...parameters.emergencyState,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="emergencyZipCode"
                    label="Zip code"
                    value={parameters.emergencyZipCode?.value}
                    onChange={(value) => valueChanged(parameters.emergencyZipCode, value)}
                />
            </Grid>
        </CategoryCard>
    );
});

export default EmergencyContact;
